module.exports = __webpack_public_path__ + "static/img/pic-bg-4.ce67bbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/pic-bg-4.png
// module id = paGS
// module chunks = 0